// development
// const ServiceURL = 'http://192.168.1.39/ectro/';
// live
const ServiceURL = 'https://backend.ectroautos.com/';
export default ServiceURL;
